import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { COLORS, SPACING } from '../styles/constants';
import { FaCheckCircle, FaHome } from 'react-icons/fa';

const ThankYouContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #032a40 0%, #001824 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 120px 40px 80px;
  text-align: center;
  color: white;
`;

const ThankYouCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  padding: 60px 40px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
  max-width: 600px;
  width: 100%;
`;

const IconContainer = styled.div`
  margin-bottom: 30px;
  
  svg {
    font-size: 5rem;
    color: ${COLORS.primary};
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 20px;
`;

const Message = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 40px;
  color: rgba(255, 255, 255, 0.9);
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
`;

const Button = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background-color: ${props => props.$primary ? COLORS.primary : 'transparent'};
  color: white;
  padding: 12px 25px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  border: 2px solid ${props => props.$primary ? COLORS.primary : 'rgba(255, 255, 255, 0.2)'};
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    background-color: ${props => props.$primary ? '#0090C0' : 'rgba(255, 255, 255, 0.1)'};
  }
`;

const ThankYou = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ThankYouContainer>
      <ThankYouCard>
        <IconContainer>
          <FaCheckCircle />
        </IconContainer>
        <Title>Thank You!</Title>
        <Message>
          Your message has been successfully sent. We appreciate your interest in JNAR's services. We will get back to you soon.
        </Message>
        <ButtonContainer>
          <Button to="/" $primary>
            <FaHome /> Return to Home
          </Button>
        </ButtonContainer>
      </ThankYouCard>
    </ThankYouContainer>
  );
};

export default ThankYou; 